import { MutableRefObject, useEffect } from 'react';

// Updates the height of a <textarea> when the value changes.
const useAutosizeTextArea = (
    textAreaRef: MutableRefObject<HTMLTextAreaElement>,
    value: string,
) => {
    useEffect(() => {
        if (textAreaRef?.current) {
            // We need to reset the height momentarily to get the correct scrollHeight for the textarea
            textAreaRef.current.style.height = '0px';
            const scrollHeight = textAreaRef.current.scrollHeight;

            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            // Guard against a 0 scrollHeight: the textarea can run this while
            // it isn't laid out yet (e.g. mounted inside a panel that's still
            // sliding open), and committing 0 collapses it to an unfocusable,
            // placeholder-less sliver with no way back — the empty value never
            // changes, so the effect wouldn't re-run. Fall back to the CSS
            // height in that case; the next keystroke re-measures correctly.
            textAreaRef.current.style.height =
                scrollHeight > 0 ? `${scrollHeight}px` : '';
        }
    }, [textAreaRef, value]);
};

export default useAutosizeTextArea;
